/**
 * State used in rendering MessageBarTitle
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
